import { Component, Input, OnInit } from '@angular/core';
import { ContentType } from '../error-prompt/error-prompt.component';
import { getAppName } from '@mode/shared/util-js';

@Component({
  selector: 'mode-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
})
export class AccessDeniedComponent implements OnInit {
  readonly appName = getAppName();
  homeUrl = '/home/';

  errorTitle!: string;
  errorExplanation!: string;
  errorInstructions!: string;
  errorPrimaryActionLabel!: string;
  errorPrimaryActionTarget!: string;

  @Input()
  isBanned!: boolean;

  @Input()
  contentType: ContentType | undefined;

  ngOnInit() {
    this.errorTitle = this.title();
    this.errorPrimaryActionLabel = this.primaryActionLabel();
    this.errorPrimaryActionTarget = this.primaryActionTarget();
    this.errorExplanation = this.explanation();
    this.errorInstructions = this.instructions();
  }

  title(): string {
    if (this.contentType === ContentType.collection) {
      return "You don't have permission to view this Collection.";
    }

    return "You don't have permission to view this content.";
  }

  explanation(): string {
    if (this.isBanned) {
      return `You have been banned or removed as a member of this Workspace.`;
    }

    if (this.contentType === ContentType.collection) {
      return 'This usually happens when someone shares a link without adding you to the Collection.';
    } else {
      return `This usually happens when you don't have access to one or more of the underlying Connections or Datasets.`;
    }
  }

  instructions(): string {
    if (this.contentType === ContentType.collection) {
      return 'To view this Collection, contact any Workspace Admin.';
    }
    return `To view this content, contact any Workspace Admin.`;
  }

  primaryActionLabel(): string {
    return `Continue to your ${this.appName} homepage`;
  }

  primaryActionTarget(): string {
    return this.homeUrl;
  }
}
